import { render } from "./HeroAreaBottomMenu.vue?vue&type=template&id=391618e2&scoped=true"
import script from "./HeroAreaBottomMenu.vue?vue&type=script&lang=js"
export * from "./HeroAreaBottomMenu.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-391618e2"

export default script